import api from './client';

// Wise supplier auto-reconciliation: outgoing Wise payments to suppliers
// matched against Gmail-sourced supplier invoices, then pushed to BR OS.
// Single bounded pass per Preview/Apply (not a multi-run chain like the
// backfill above) -- see services/wise_supplier_reconciliation.py.
export const wiseSupplierReconciliationAPI = {
  status: () => api.get('/admin/wise-supplier-reconciliation/status'),
  setFlag: (enabled) => api.post('/admin/wise-supplier-reconciliation/flag', { enabled }),
  previewStart: () => api.post('/admin/wise-supplier-reconciliation/preview/start'),
  applyStart: () => api.post('/admin/wise-supplier-reconciliation/apply/start'),
  jobStatus: (jobId) => api.get(`/admin/wise-supplier-reconciliation/job-status/${jobId}`),
  jobLatest: (operation) => api.get(`/admin/wise-supplier-reconciliation/job-latest/${operation}`),
  recent: () => api.get('/admin/wise-supplier-reconciliation/recent'),
  retryBrosPush: (matchId, bookingRef) =>
    api.post('/admin/wise-supplier-reconciliation/retry-bros-push', { match_id: matchId, booking_ref: bookingRef }),
  invoiceStoreCensus: () => api.get('/admin/wise-supplier-reconciliation/invoice-store-census'),
  corroboratedApprovals: () => api.get('/admin/wise-supplier-reconciliation/corroborated-approvals'),
  brosLinkStatus: () => api.get('/admin/wise-supplier-reconciliation/bros-link-status'),
  brOsPaidDivergence: () => api.get('/admin/wise-supplier-reconciliation/br-os-paid-divergence'),
};
